import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "manager-requests__list-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "manager-requests__list--empty"
}
const _hoisted_3 = { class: "manager-requests__actions" }
const _hoisted_4 = {
  key: 0,
  class: "manager-requests__replies-table"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  class: "manager-requests__reply-cell-first",
  style: {"width":"244px"}
}
const _hoisted_7 = {
  class: "manager-requests__reply-cell",
  style: {"width":"311px"}
}
const _hoisted_8 = {
  class: "manager-requests__reply-cell",
  style: {"width":"385px"}
}
const _hoisted_9 = {
  class: "manager-requests__reply-cell",
  style: {"width":"127px"}
}

import {computed, ref, watch} from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import type { Request, RequestStatus } from '../types';
import StatusFilterSimple from './StatusFilterSimple.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'RequestsList',
  props: {
    requests: {},
    loading: { type: Boolean },
    selectedStatus: {}
  },
  emits: ["update:selected-status", "row-click", "delete-request", "reply"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const expandedRows = ref<Record<number, boolean>>({});

const selectedStatusLocal = computed({
  get: () => props.selectedStatus,
  set: (value) => emit('update:selected-status', value),
});

watch(
  () => props.requests,
  (newRequests) => {
    // Раскрываем все заявки с ответами
    const newExpandedRows: Record<number, boolean> = {};
    newRequests.forEach((request) => {
      if (request.replies && request.replies.length > 0) {
        newExpandedRows[request.id] = true;
      }
    });
    expandedRows.value = newExpandedRows;
  },
  { immediate: true }
);

const replyModalVisible = ref(false);
const selectedReplyMessage = ref('');

function hasReplies(request: Request): boolean {
  return !!(request.replies && request.replies.length > 0);
}

function getChevronIcon(id: number): string {
  return expandedRows.value[id] ? 'pi pi-chevron-up' : 'pi pi-chevron-down';
}

function toggleExpand(id: number) {
  if (expandedRows.value[id]) {
    delete expandedRows.value[id];
  } else {
    expandedRows.value = { ...expandedRows.value, [id]: true };
  }
}

function showReplyModal(message: string) {
  selectedReplyMessage.value = message;
  replyModalVisible.value = true;
}

function onRowClick(event: any) {
  const data = event.data;
  emit('row-click', data);
}

function getRequestRowClass(request: Request) {
  const baseClass = 'manager-requests__table-row';
  const newStatusClass = request.status === 'Новая' ? ' manager-requests__new-status' : '';
  return baseClass + newStatusClass;
}

function formatDate(isoString: string): string {
  return new Date(isoString).toLocaleString('ru-RU');
}

function getStatusClass(status: RequestStatus): string {
  return `manager-requests__status manager-requests__status--${status
    .toLowerCase()
    .replace(/\s+/g, '-')}`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(StatusFilterSimple, {
      modelValue: selectedStatusLocal.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedStatusLocal).value = $event))
    }, null, 8, ["modelValue"]),
    (props.requests.length === 0 && !__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Нет поступивших заявок "))
      : (_openBlock(), _createBlock(_unref(DataTable), {
          key: 1,
          expandedRows: expandedRows.value,
          "onUpdate:expandedRows": _cache[1] || (_cache[1] = ($event: any) => ((expandedRows).value = $event)),
          loading: __props.loading,
          rows: 10,
          rowsPerPageOptions: [10, 25, 50],
          value: props.requests,
          onRowClick: onRowClick,
          dataKey: "id",
          paginator: "",
          selectionMode: "single",
          tableStyle: "min-width: 70rem"
        }, {
          loading: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createElementVNode("div", { class: "manager-requests__loading" }, [
              _createElementVNode("i", {
                class: "pi pi-spinner pi-spin",
                style: {"font-size":"2rem"}
              }),
              _createElementVNode("span", null, "Загрузка...")
            ], -1)
          ]))]),
          expansion: _withCtx(({ data }) => [
            (hasReplies(data))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.replies, (reply) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: reply.id,
                      class: "manager-requests__reply-row",
                      onClick: ($event: any) => (showReplyModal(reply.message))
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _cache[4] || (_cache[4] = _createElementVNode("i", { class: "pi pi-reply reply-icon" }, null, -1)),
                        _createElementVNode("span", null, "#" + _toDisplayString(data.id), 1)
                      ]),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(formatDate(data.createdAt)), 1),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(data.companyName || ''), 1),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", {
                          class: _normalizeClass(getStatusClass(data.status))
                        }, _toDisplayString(data.status), 3)
                      ]),
                      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "manager-requests__reply-cell manager-requests__reply-actions" }, null, -1))
                    ], 8, _hoisted_5))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(Column), { style: {"width":"3rem"} }, {
              body: _withCtx(({ data }) => [
                (hasReplies(data))
                  ? (_openBlock(), _createBlock(_unref(Button), {
                      key: 0,
                      icon: getChevronIcon(data.id),
                      text: "",
                      onClick: _withModifiers(($event: any) => (toggleExpand(data.id)), ["stop"]),
                      class: "p-0 manager-requests__expander-button"
                    }, null, 8, ["icon", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "№ заявки" }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(getRequestRowClass(data))
                }, " #" + _toDisplayString(data.id), 3)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Дата и время" }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(getRequestRowClass(data))
                }, _toDisplayString(formatDate(data.createdAt)), 3)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Компания" }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(getRequestRowClass(data))
                }, _toDisplayString(data.companyName || ''), 3)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Статус" }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(getStatusClass(data.status))
                }, _toDisplayString(data.status), 3)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              header: "Действия",
              style: {"width":"120px"}
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(Button), {
                    icon: "pi pi-reply",
                    text: "",
                    onClick: _withModifiers(($event: any) => (emit('reply', data)), ["stop"]),
                    "aria-label": "Ответить"
                  }, null, 8, ["onClick"]),
                  _createVNode(_unref(Button), {
                    icon: "pi pi-trash",
                    severity: "danger",
                    text: "",
                    onClick: _withModifiers(($event: any) => (_ctx.$emit('delete-request', data.id)), ["stop"])
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["expandedRows", "loading", "value"])),
    _createVNode(_unref(Dialog), {
      visible: replyModalVisible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((replyModalVisible).value = $event)),
      modal: "",
      header: "Ответ",
      style: { width: '90vw', maxWidth: '800px', height: 'auto' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(selectedReplyMessage.value), 1)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})